<template>
  <v-layout row justify-center id="scrollWrapper">

        <v-card  elevation="0" style="min-width: 100% !important;">
          <v-card-text class="pa-0" v-if="$dataLoaded">
            <v-container>
              <v-flex xs12>
            <v-text-field
                    @input="doSearchResultsDebounced(); searching = true"
              v-model="searchValue"
              color="cyan darken"
              prepend-icon="search"
              label="Document Search"
              placeholder="Start typing..."
              clearable
            >
            </v-text-field>
              </v-flex>
              <v-flex xs12>

                <v-btn v-if="1==2" @click="test()">Test</v-btn>

            <v-radio-group @change="doSearchResults" v-model="limitSearch" row>
              <template v-slot:label>
                <span style="margin-right: 10px">Show results from: </span>
              </template>
              <v-radio label="All" value="all"></v-radio>
              <v-radio v-for="item in localDocTypes" :label="item.title" :value="item.id"></v-radio>
            </v-radio-group>

                <v-container style="padding-top: 0px !important;">

              <v-layout row wrap v-if="limitSearch.includes('policies')" >
              <v-radio-group @change="doSearchResults" v-model="policyTypeFilter" row>

                <template v-slot:label>
                  <span style="margin-right: 10px">Policy Type Filter: </span>
                </template>
                <v-radio label="None" value="all"></v-radio>
                <v-radio v-for="item in $policyTypes" :label="item.title" :value="item.id"></v-radio>
              </v-radio-group>
              </v-layout>

              <v-layout row wrap v-else-if="limitSearch === 'serviceManuals'" >
                <v-flex md8 xs12 v-if="1==2">
              <v-radio-group row @change="doSearchResults" v-model="serviceManualTypeFilter">
                <template v-slot:label>
                  <span style="margin-right: 10px">Revision Type Filter: </span>
                </template>
                <v-radio label="None" value="all"></v-radio>
                <v-radio label="Statute" value="S"></v-radio>
                <v-radio label="Law" value="L"></v-radio>
                <v-radio label="Rule" value="R"></v-radio>
              </v-radio-group>
                </v-flex>

              </v-layout>

              <v-layout row wrap v-else-if="limitSearch === 'publications' || limitSearch === 'resources'" >
                <v-flex xs12 md3>
                  <v-select v-if="limitSearch === 'publications'" clearable @change="doSearchResults" v-model="publicationTypeFilter" required v-bind:items="$publicationTypes" label="Publication Type Filter"
                            ></v-select>
                  <v-select v-else clearable @change="doSearchResults" v-model="resourceTypeFilter" required v-bind:items="$resourceTypes" label="Resource Type Filter"
                  ></v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <span style="font-weight: 500; color: grey; text-align: right; display: block;">Publication Date Filter</span>
                </v-flex>

                <v-flex xs6 md3>
                  <v-dialog
                    ref="dateFromDialog"
                    v-model="dateFromDialog"
                    :return-value.sync="dateFrom"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                            @change="doSearchResults"
                      slot="activator"
                      :value="formatDate(dateFrom)"
                      label="From"
                      prepend-icon="event"
                      readonly
                      clearable
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateFrom" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="dateFromDialog = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dateFromDialog.save(dateFrom);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>

                <v-flex xs6 md3>
                  <v-dialog
                    ref="dateToDialog"
                    v-model="dateToDialog"
                    :return-value.sync="dateTo"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                            @change="doSearchResults"
                      slot="activator"
                      :value="formatDate(dateTo)"
                      label="To"
                      prepend-icon="event"
                      readonly
                      clearable
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateTo" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="dateToDialog = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dateToDialog.save(dateTo);">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>

              </v-layout>

                </v-container>
              </v-flex>

              <v-divider></v-divider>
            </v-container>

            <v-container v-if="searching && searchValue != null">
              <v-flex style="text-align: center" >
                <v-progress-circular
                        :size="50"
                        :width="5"
                        color="#2196f3"
                        indeterminate
                ></v-progress-circular>
                <br/>
                <br/>
                <h3>Searching...</h3>
              </v-flex>
            </v-container>

            <v-container v-else-if="permissions">
              <v-flex style="text-align: center" >
                <p>Document Filter: {{documentFilter}}</p>
                <v-btn  @click="$emit('closed');">Close</v-btn>
              </v-flex>
            </v-container>

            <v-container v-else  id="SearchResultsWrapper2">
              <v-flex style="text-align: center" v-if="currentPage != null">
                <p><b>Page {{currentPage.label}} of {{pages[pages.length-1].label}}</b></p>
              </v-flex>
              <v-flex xs 12 v-if="searchValue === null || searchValue.trim().length == 0">
                <span style="text-align: center; color: #d41616; display: block;">Enter a search query</span>
              </v-flex>
              <v-flex xs 12 v-else-if="searchResults.length === 0">
                <span style="text-align: center; color: #d41616; display: block;">No Results Found</span>
              </v-flex>
              <v-flex xs12 v-for="(result, index) in searchResultsPaginated" :key="index">
                <v-card hover @click="openDoc(result)">
                  <v-chip v-if="result.docType != 'school law'" style="float:right;">
                    {{smartDocType(result)}}
                  </v-chip>
                  <v-chip v-else style="float:right;">
                    School Law
                  </v-chip>
                <v-flex x12 style="border-bottom: 1px solid #80808029;">
                  <h3 style="display: inline-block;">
                    {{result.docType !== 'school law' ? result.title : (result.revnumber + ' | ' + result.citation )}}</h3></v-flex>
                <v-flex xs12 v-if="result.docType === 'Policy'">
                  <div class="text-xs-left">
                    <text-highlight  style="max-height: 40px; overflow: hidden;"
                                     :queries="queries">{{ result.returnBody }}</text-highlight>
                  </div>
                </v-flex>
                  <v-flex xs12 v-if="result.docType === 'Publication'">
                    <div class="text-xs-left">
                      <text-highlight  style="max-height: 40px; overflow: hidden;"
                                       :queries="queries">{{ result.returnBody }}</text-highlight>
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="result.docType === 'Resource'">
                    <div class="text-xs-left">
                      <text-highlight  style="max-height: 40px; overflow: hidden;"
                                       :queries="queries">{{ result.keywords }}</text-highlight>
                    </div>
                  </v-flex>
                  <v-flex xs12 v-if="result.docType === 'school law'">
                    <div class="text-xs-left">
                      <text-highlight  style="max-height: 40px; overflow: hidden;"
                                       :queries="queries">{{ result.description }}</text-highlight>
                    </div>
                  </v-flex>


                </v-card>
              </v-flex>
              <v-flex xs12 style="text-align: center;">
                <v-btn  v-for="page in pages" @click="setPage(page)"
                        v-bind:class="{ blue: currentIndexPagination == page.start }">{{page.label}}</v-btn>
              </v-flex>

            </v-container>

          </v-card-text>
          <v-card-text v-else>
            <v-container>
              <v-flex style="text-align: center" >
                <v-progress-circular
                        :size="100"
                        :width="10"
                        color="#2196f3"
                        indeterminate
                ></v-progress-circular>
                <br/>
                <br/>
                <h3 v-if="doc == undefined">Loading Search Engine</h3>
                <h3 v-else>Loading Resources</h3>
              </v-flex>
            </v-container>
          </v-card-text>
        </v-card>
</v-layout>
</template>

<script>
  import moment from 'moment'
  import _ from 'lodash';
  const htmlToText = require('html-to-text');
  const worker = new Worker('../fuseworker.js', { type: 'module' })


export default {
  name: 'TypeAhead',
  props: ['doc', 'selecting', 'permissions'],
  data () {
    return {
      pageHeight: null,
      loaded: false,
      openedDoc: null,
      searching: false,
      currentIndexPagination: 0,
      currentPage: null,
      itemsPerPage: 5,
      dateFrom: '',
      searchResults: [],
      dateTo: '',
      dateFromDialog: false,
      dateToDialog: false,
      serviceManualTypeFilter: null,
      serviceManualChapterSearch: null,
      policyTypeFilter: null,
      publicationTypeFilter: null,
      resourceTypeFilter: null,
      dialog: false,
      searchValue: '',
      limitSearch: 'all',
      resourceTypes: ["Form", "Resolution", "Model Agreement", "Informational Resource", "Sample Document"],
      publicationTypes: ["Leader", "Journal", "Weekly Advocate", "MSBA Advocate"],
      revisionTypes: [{title: "Statute", id: 'S'}, {title: "Law", id: 'L'}, {title: "Rule", id: 'R'}],
      policyTypes: [{title: "Mandatory", id: 'M'}, {title: "Legislative", id: 'L'}, {title: "Recommended", id: 'R'}],
    }
  },
  computed: {
      localDocTypes() {
        return [
          {title: "District Policies", id: 'districtpolicies'},
          {title: "Charter Policies", id: 'charterpolicies'},
          {title: "School Law", id: 'serviceManuals'},
          {title: "Publications", id: 'publications'},
          {title: "Resources", id: 'resources'},
          {title: "Website", id: 'website'}]
      },
      documentFilter() {
        var returnVal = null
        if(this.limitSearch.includes('policies') && this.policyTypeFilter != null)
          returnVal = this.policyTypeFilter;
        else if(this.limitSearch == 'publications' && this.publicationTypeFilter != null)
          returnVal = this.publicationTypeFilter
        else if(this.limitSearch == 'resources' && this.resourceTypeFilter != null)
          returnVal = this.resourceTypeFilter

        this.$emit('documentFilter', returnVal);
        this.$emit('documentType', this.limitSearch);
        return returnVal
      },
      pages() {
          var toReturn = []
          var labelCount = 1

          for(var i=0; i < this.searchResults.length; i+=this.itemsPerPage) {
              toReturn.push({
                  start: i,
                  label: labelCount

              })
              labelCount++
          }

          console.log('pages is', toReturn)

          this.currentPage = toReturn[0]

          return toReturn;

      },
    searchResultsPaginated() {
        var endIndex = this.currentIndexPagination + this.itemsPerPage
        if(endIndex > this.searchResults.length) {
            endIndex = undefined
        }
        console.log('pagination result', this.searchResults)
        return this.searchResults.slice(this.currentIndexPagination, endIndex);
    },
    queries() {
      var toReturn = [];
        if(this.searchValue === null) {
          //this.searchValue = ''
        } else {
          toReturn.push(this.searchValue)
          this.searchValue.split(' ').forEach((queryWord)=>{
            if(queryWord.length > 3) {
              toReturn.push(queryWord)
            }
          })
        }

        return toReturn

    },
    searchItems() {
      var itemsToSearch = []
      var toReturn = []
      console.log('limit to', this.limitSearch)

      var chapterFilterValid = (this.serviceManualChapterSearch !== null && this.serviceManualChapterSearch.trim().length > 0)
      var typeFilterValid = (this.serviceManualTypeFilter !== null && this.serviceManualTypeFilter !== 'all')

      if (this.limitSearch === 'all' || this.limitSearch === 'districtpolicies' ) {
        itemsToSearch = itemsToSearch.concat(this.$policies.filter((policy)=>policy.ischarter !== 1).map(obj => ({ ...obj, docType: 'Policy'})))
      }
      if (this.limitSearch === 'all' || this.limitSearch === 'charterpolicies' ) {
        console.log(itemsToSearch)
        itemsToSearch = itemsToSearch.concat(this.$policies.filter((policy)=>policy.ischarter === 1).map(obj => ({ ...obj, docType: 'Policy'})))
      }
      if (this.limitSearch === 'all' || this.limitSearch === 'publications' ) {
        itemsToSearch = itemsToSearch.concat(this.$publications.map(obj => ({ ...obj, docType: 'Publication' })))
      }
      if (this.limitSearch === 'all' || this.limitSearch === 'resources' ) {
        itemsToSearch = itemsToSearch.concat(this.$resources.map(obj => ({ ...obj, docType: 'Resource' })))
      }
      if (this.limitSearch === 'all' || this.limitSearch === 'serviceManuals' ) {
        itemsToSearch = itemsToSearch.concat(this.$serviceManuals.map(obj => ({ ...obj, docType: 'school law' })))
      }
      if (this.limitSearch === 'all' || this.limitSearch === 'website' ) {
        itemsToSearch = itemsToSearch.concat(this.$webpages.map(obj => ({ ...obj, docType: 'Website' })))
      }

      itemsToSearch.forEach((item) => {
        /*item.textOnlyBody = htmlToText.fromString(item.body, {
          wordwrap: 130
        }); */
        item.textOnlyBody = item.searchcontent

          if(item.textOnlyBody  == null || item.textOnlyBody == undefined) {
              item.textOnlyBody = ''
          }
      })

      console.log('this.limitSearch',this.limitSearch)
      if (this.limitSearch.includes('policies')  && this.policyTypeFilter !== null &&  this.policyTypeFilter !== 'all') {
        itemsToSearch.forEach((item) => {
          if (item.type === this.policyTypeFilter) {
            toReturn.push(item)
          }
        })
      } else if (this.limitSearch === 'serviceManuals') {
        if (chapterFilterValid && typeFilterValid) {
          itemsToSearch.forEach((item) => {
            if (item.revtype === this.serviceManualTypeFilter && item.chapter.toLowerCase().includes(this.serviceManualChapterSearch)) {
              toReturn.push(item)
            }
          })
        } else if (typeFilterValid) {
          itemsToSearch.forEach((item) => {
            if (item.revtype === this.serviceManualTypeFilter) {
              toReturn.push(item)
            }
          })
        } else if (chapterFilterValid) {
          itemsToSearch.forEach((item) => {
            if (item.chapter.toLowerCase().includes(this.serviceManualChapterSearch)) {
              toReturn.push(item)
            }
          })
        }
      } else if (this.limitSearch === 'publications' && this.publicationTypeFilter !== null && this.publicationTypeFilter !== undefined) {
        itemsToSearch.forEach((item) => {
          if (item.type === this.publicationTypeFilter) {
            toReturn.push(item)
          }
        })
      } else if (this.limitSearch === 'resources' && this.resourceTypeFilter !== null && this.resourceTypeFilter !== undefined) {
        itemsToSearch.forEach((item) => {
          if (item.type === this.resourceTypeFilter) {
            toReturn.push(item)
          }
        })
      } else {
        toReturn = itemsToSearch
      }

      console.log('itemsToSearch', itemsToSearch);

      return toReturn;
    }
  },
  mounted() {
    console.log('mounted type ahead', this.doc)

    this.calculateHeight()

    setInterval(this.calculateHeight,250);

  },
  watch: {
    searchValue: _.debounce(function(newVal){
      /*
       sessionID: DataTypes.STRING,
    dynamicsID: DataTypes.STRING,
    fullName: DataTypes.STRING,
    searchTerm: DataTypes.STRING,
    searchFilter: DataTypes.STRING,
    documentTitle: DataTypes.STRING,
    documentLink: DataTypes.STRING,
    eventType: DataTypes.STRING
       */


      if(this.searchValue != null && this.searchValue.length > 2) {
        this.$sendLogEntry({
          'searchTerm': this.searchValue,
          'searchFilter' : this.limitSearch,
          'eventType' : 'query'
        })
      }
    }, 1000)
  },
  methods: {
    smartDocType(doc){
      if(doc.docType == 'Policy') {
        if(doc.ischarter == 1)
          return 'Charter Policy'
        else
          return 'District Policy'
      } else {
        return doc.docType
      }
    },
    calculateHeight() {
      let newHeight = null
      if (this.openedDoc == null && document.getElementById("scrollWrapper") != undefined)
        newHeight = document.getElementById("scrollWrapper").scrollHeight
      else if (document.getElementById("documentDialogContent") != undefined)
        newHeight = document.getElementById("documentDialogContent").scrollHeight + 75
      //newHeight = document.getElementsByClassName("documentDialog")[0].scrollHeight

      if(newHeight != this.pageHeight) {
        console.log('height changed', newHeight)
        let message = JSON.stringify({
          event: 'height',
          data: newHeight,
        });
        window.parent.postMessage(message, '*');
        this.pageHeight = newHeight
      }
    },
      setPage(page) {
        this.$sendLogEntry({
          'searchPage' : page.label,
          'eventType' : 'page'
        })
          this.currentIndexPagination = page.start;
          this.currentPage = page;
          document.getElementById('SearchResultsWrapper').scrollIntoView()
      },
      findConcentrationOfMatches(matches) {
        if(matches == undefined)
          return

        console.log('findConcentrationOfMatches', matches)
        matches.indices.forEach((indicy)=>{
          console.log('indicy',matches.value.substring(indicy[0] , indicy[1]))
        })
      },
      doSearchResultsDebounced: _.debounce(function (e) {
          console.log('bounced')
          this.doSearchResults()
      }, 250),
      doSearchResults() {
        console.log('in doSearchResults', this.queries)
        this.searchResults = []
        if(this.queries.length > 0) {
          this.searching = true
          console.log('its!!!!!!!!!!!', this.searchItems)
          worker.postMessage({
            "searchItems": this.searchItems,
            "searchValue": this.searchValue
          })

          worker.onmessage = (e) => {

            console.log('these are search results', e.data)
            this.searchResults = e.data
            this.searching = false
          }

        }
      },
    formatDate (date) {
      return date ? moment(date).format('MM/DD/YYYY') : ''
    },
    openDoc(doc) {
      if(!this.selecting) {
        console.log('sending log entry for open')
        this.$sendLogEntry({
          documentTitle: doc.title,
          documentLink: this.$router.resolve({name: 'ViewDocument', params: {type: doc.docType.toLowerCase(), id: doc.id}}).href,
          'eventType' : 'open'
        })
      }

      if(this.selecting) {
        this.$emit('selected', doc)
        this.searchValue = ''
      }
      else if(doc.docType == "Website" || (doc.docType == "Publication" && doc.link)) {

        window.open(doc.link, '_blank');
      }
      else {
        console.log('pushing doc', doc)
        this.$router.push({name: 'ViewDocument', params: {type: doc.docType.toLowerCase(), id: doc.id}})
      }
    }
  }
}
</script>
